import props from '../layoutProps';
import image from '../../../../../static/learning-primary2@large.jpg';

const key = 'primary-school';

export default {
  ...props,
  rootNavKey: [...props.rootNavKey, key],
  parentKeys: [...props.parentKeys, key],
  image,
};
